"use client";

import { useContext } from "react";
import { useFormStatus } from "react-dom";
import { Button } from "@mui/material";
import { useEditDialog } from "../Providers/EditDialogContext";
import { FilterParamsContext } from "@/stories/SearchDrawerComponents/FilterParamsProvider";

export default function SubmitButton() {
  const { pending } = useFormStatus();
  const { filterParams } = useContext(FilterParamsContext);
  const { campaignIdToEdit, campaignName, campaignType, searchTerms } =
    useEditDialog();

  // Check if all required values are present
  const isDisabled =
    pending ||
    !campaignIdToEdit ||
    !campaignName ||
    !campaignType ||
    !filterParams ||
    Object.keys(searchTerms).length === 0;

  return (
    <Button type="submit" variant="contained" disabled={isDisabled}>
      {pending ? "Updating..." : "Update"}
    </Button>
  );
}
